var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuGeneralRoomUnitInfrared = function SvgDAhuGeneralRoomUnitInfrared(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M503,88.5c-5.79,0-10.5-4.71-10.5-10.5s4.71-10.5,10.5-10.5,10.5,4.71,10.5,10.5-4.71,10.5-10.5,10.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503,68c5.51,0,10,4.49,10,10s-4.49,10-10,10-10-4.49-10-10,4.49-10,10-10M503,67c-6.08,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M499.19,70c1.1,0,2,.9,2,2v12c0,1.1-.9,2-2,2v-16Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.19,77h1c.55,0,1,.45,1,1h0c0,.55-.45,1-1,1h-1v-2h0Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.89,74.62c.86.86,1.4,2.05,1.4,3.37s-.52,2.49-1.37,3.35",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.75,72.76c1.34,1.34,2.17,3.19,2.17,5.23s-.83,3.89-2.17,5.23",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.61,70.91c1.81,1.81,2.93,4.32,2.93,7.08s-1.12,5.27-2.93,7.08",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
export default SvgDAhuGeneralRoomUnitInfrared;